module.exports = __webpack_public_path__ + "img/SQ.0275bd07.jpg";